import * as Y from 'yjs';
import * as encoding from 'lib0/encoding';
import * as decoding from 'lib0/decoding';
import {openDB} from 'idb';
import {ADORANS_WORKSPACE_ID} from '../../shared/services/workspaceAccess';

// Recovery is a one-way read. Never use WebsocketProvider here: it would
// publish historical offline changes back to the legacy server.
export async function readLegacyCache(workspaceId, doc) {
  let db;
  try {
    // Abort creation of missing databases: opening an empty DB would interfere
    // with y-indexeddb's later initialization of this legacy workspace.
    db = await openDB(workspaceId, undefined, {upgrade: (_db, _old, _next, transaction) => transaction.abort()});
  } catch (error) {
    if (error.name === 'AbortError') return;
    throw error;
  }
  try {
    if (!db.objectStoreNames.contains('updates')) return;
    const updates = await db.getAll('updates');
    updates.forEach(update => Y.applyUpdate(doc, update));
  } finally {db.close();}
}

export function readLegacyServer(doc, workspaceId, {
  endpoint = `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}/legacy-ws`,
  Socket = window.WebSocket, timeoutMs = 15000,
} = {}) {
  return new Promise((resolve, reject) => {
    const socket = new Socket(`${endpoint}/${encodeURIComponent(workspaceId)}`);
    socket.binaryType = 'arraybuffer';
    const finish = error => {
      clearTimeout(timer);
      socket.onopen = socket.onmessage = socket.onerror = socket.onclose = null;
      socket.close();
      if (error) reject(error); else resolve();
    };
    const timer = setTimeout(() => finish(new Error('Stary serwer nie odpowiedział. Spróbuj ponownie lub pobierz kopię lokalną.')), timeoutMs);
    socket.onopen = () => {
      const message = encoding.createEncoder();
      encoding.writeVarUint(message, 0); // Yjs sync
      encoding.writeVarUint(message, 0); // sync step 1 only
      // Request the entire server state, including changes already in the cache.
      encoding.writeVarUint8Array(message, new Uint8Array([0]));
      socket.send(encoding.toUint8Array(message));
    };
    socket.onmessage = event => {
      try {
        const message = decoding.createDecoder(new Uint8Array(event.data));
        if (decoding.readVarUint(message) !== 0) return; // ignore awareness
        const type = decoding.readVarUint(message);
        if (type !== 1 && type !== 2) return; // never reply to server step 1
        Y.applyUpdate(doc, decoding.readVarUint8Array(message));
        if (type === 1) finish();
      } catch (error) {finish(error);}
    };
    socket.onerror = () => finish(new Error('Nie udało się odczytać starej sesji.'));
    socket.onclose = () => finish(new Error('Połączenie zamknięto przed odczytem sesji.'));
  });
}

export async function readLegacySession(sessionId, {localOnly = false, ...options} = {}) {
  if (!/^[a-zA-Z0-9-]{1,128}$/.test(sessionId || '')) throw new Error('Nieprawidłowy identyfikator sesji.');
  const workspaceId = `songs-storage-${sessionId}`;
  if (workspaceId === ADORANS_WORKSPACE_ID) throw new Error('Adorans jest już w Hosannie.');
  const doc = new Y.Doc();
  try {
    await readLegacyCache(workspaceId, doc);
    if (!localOnly) await readLegacyServer(doc, workspaceId, options);
    return doc;
  } catch (error) {doc.destroy(); throw error;}
}
